import classNames from 'classnames';
import { times } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const DOT_SIZE = 6;
const ACTIVE_DOT_SIZE = 9;

const Dots = ({ nDots, activeIndex, onClick }) => (
  <div className="Dots">
    {times(nDots, index => (
      <button
        className={classNames('Dots__dot-container', {
          'Dots__dot-container--active': index === activeIndex,
        })}
        aria-label={I18n.localize('carousel.viewSlide', { slideIndex: index })}
        onClick={() => onClick(index)}
        key={index}
      >
        <div className="Dots__dot" />
      </button>
    ))}
    <style jsx>
      {`
        .Dots {
          position: absolute;
          display: flex;
          bottom: ${Theme.get('spacing') * 13}px;
          left: ${Theme.get('spacing') * 22}px;
        }

        .Dots__dot-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: ${Theme.get('spacing')}px;
          background-color: transparent;
          cursor: pointer;
          border: none;
          outline: 0;
        }

        .Dots__dot-container.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }

        .Dots__dot {
          width: ${DOT_SIZE}px;
          height: ${DOT_SIZE}px;
          background-color: ${Theme.get('colors-black')};
          border-radius: 50%;
          opacity: 0.5;
          transition: opacity 0.2s ease-out;
        }

        .Dots__dot-container--active .Dots__dot {
          width: ${ACTIVE_DOT_SIZE}px;
          height: ${ACTIVE_DOT_SIZE}px;
          opacity: 1;
        }
      `}
    </style>
  </div>
);

Dots.propTypes = {
  nDots: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Dots;
